import { render, staticRenderFns } from "./ZjdJiuzheng.vue?vue&type=template&id=04c66331&scoped=true"
import script from "./ZjdJiuzheng.vue?vue&type=script&lang=js"
export * from "./ZjdJiuzheng.vue?vue&type=script&lang=js"
import style0 from "./ZjdJiuzheng.vue?vue&type=style&index=0&id=04c66331&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c66331",
  null
  
)

export default component.exports